import type { ProductTourDef } from '@core/models/product-tour.model';

/** The lead-management tour definitions, imported only when a tour starts. */
export function loadLeadManagementTours(): Promise<readonly ProductTourDef[]> {
  return import('@features/lead-management/constants/lead-management-tour-registry.constants').then(
    m => m.LEAD_MANAGEMENT_TOUR_REGISTRY
  );
}
